import SessionsTag from 'core/modules/compositions/SessionsTag/SessionsTag';
import PropTypes from 'prop-types';
import React from 'react';
import { Tag } from 'ui';

function LessonItemCardSession({ sessions = [], isTeacherOnly, t, canEditSessions, lessonItemGuid, courseGuid, onSaveSessions, lessonGuid }) {
  return (
    <div className="lesson-item-card-session">
      <SessionsTag
        sessions={sessions}
        canEditSessions={canEditSessions}
        lessonItemGuid={lessonItemGuid}
        courseGuid={courseGuid}
        onSaveSessions={onSaveSessions}
        lessonGuid={lessonGuid}
      />

      {isTeacherOnly && <Tag color="primary" label={t('lesson:Teacher only')} leftIcon="teacher" />}
    </div>
  );
}

LessonItemCardSession.propTypes = {
  canEditSessions: PropTypes.bool,
  lessonItemGuid: PropTypes.string,
  courseGuid: PropTypes.string,
  onSaveSessions: PropTypes.func,
  isTeacherOnly: PropTypes.bool,
  sessions: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
    })
  ),
  t: PropTypes.func,
  lessonGuid: PropTypes.string,
};

export default LessonItemCardSession;
